import { WebApi } from '@/services/WebApi'

const state = () => ({
  contactRelationshipOptions: [],
  fetchingContactRelationshipOptions: false,
  fetchedContactRelationshipOptions: false
})

const mutations = {
  setFetching (state, fetching) {
    state.fetchedContactRelationshipOptions = false
    state.fetchingContactRelationshipOptions = !!fetching
  },
  setContactRelationshipOptions (state, options) {
    state.contactRelationshipOptions = options
    state.fetchedContactRelationshipOptions = true
    state.fetchingContactRelationshipOptions = false
  }
}

const actions = {
  fetchContactRelationshipOptionsBySiteId ({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      commit('setFetching', true)
      WebApi.get('Portal/' + siteId + '/Contact/Relationship/Option')
        .then(response => { commit('setContactRelationshipOptions', response.data); resolve(response) })
        .catch(error => { commit('setFetching', false); reject(error) })
    })
  }
}

export default { namespaced: true, state, mutations, actions }
